import {cgiUnescape} from "./cgiUnescape"
import {EmbedCodeExtractor} from "./types"

const PATTERNS = [
  /src="(https?:\/\/www.dpa-video.com\/\S+)"/i
]

/**
 * Port of Tik::WebEmbedService::PreProcessor::DpaVideo (pre_processor/dpa_video.rb):
 * extracts the dpa-video URL from an iframe embed code and CGI-unescapes it
 * (shared isomorphic decoder, design D5).
 */
export const dpaVideoPreProcessor: EmbedCodeExtractor = (input: string) => {
  for(const pattern of PATTERNS) {
    const match = pattern.exec(input)
    if(match) {
      return cgiUnescape(match[1])
    }
  }
  return null
}
